var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}},[_c('g',{staticClass:"cls-1"},[_c('line',{attrs:{"x1":"52","y1":"14","x2":"52","y2":"90"}}),_c('line',{attrs:{"x1":"14","y1":"52","x2":"90","y2":"52"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }